(function ($) {
    $(function () {
        let closeBtn = $("#closeBtn"),
            acceptBtn = $("#acceptBtn"),
            cookiesMsg = $("#cookiesMsg"),
            cookiePolicy = getCookie("cookiepolicy"),
            localStPolicy = localStorage.getItem('cookiepolicy');


        if ($html.hasClass("embed")) {
            collapseMessage();
        }

        let newCookie = 'bank';

        if (!cookiePolicy && !localStPolicy) {
            cookiesMsg.show();
        } else {
            let patrs = cookiePolicy.split('.');
            if (!patrs.includes(newCookie)) {
                cookiesMsg.show();
                patrs.push(newCookie);
                newCookie = patrs.join('.');
            }
        }

        let coExpDate  = new Date().getTime()  + 31557600000; // 1 year
        if(iOS()) coExpDate    = (new Date().getTime() + 13149000000); // 5 month

        closeBtn.on("click", collapseMessage);
        acceptBtn.on("click", function () {
            localStorage.setItem("cookiepolicy",newCookie);
            setCookie(
                "cookiepolicy",
                newCookie,
                coExpDate,
                "/"
            );
            collapseMessage();
        });

        function collapseMessage() {
            cookiesMsg.addClass("hidden-msg");
        }
    });
})(jQuery);